import UserSession from '@/infrastructure/user-session';
import WsManager from '@/infrastructure/ws-manager';

export default class Bootstrapper {
	public static async bootstrap(): Promise<void> {
		if (!UserSession.isValid()) {
			const error = new Error('No valid session found');
			error.name = 'NotAuthorizedException';
			throw error;
		}

		await UserSession.acquireCredentials();
		WsManager.initialize();
		window.addEventListener('pagehide', () => WsManager.release(), { once: true });
	}
}
